module.exports = __webpack_public_path__ + "html/bd-controls.template.html";